import { createStore } from 'zustand';
import { createStoreContext } from '../utils/create-store-context';

type ProductStickyNavData = {
	currentActiveSection: string;
	shouldShowATC: boolean;
	sectionToOpen: string;
};

type ProductStickyNavActions = {
	setCurrentActiveSection: (currentActiveSection: string) => void;
	setShouldShowATC: (shouldShowATC: boolean) => void;
	setSectionToOpen: (sectionToOpen: string) => void;
};

export type ProductStickyNavState = ProductStickyNavData & ProductStickyNavActions;

export type ProductStickyNavInitialState = Partial<ProductStickyNavData>;

export const createProductStickyNavStore = (initialState: ProductStickyNavInitialState = {}) =>
	createStore<ProductStickyNavState>((set) => ({
		currentActiveSection: '',
		shouldShowATC: false,
		sectionToOpen: '',
		...initialState,
		setCurrentActiveSection: (currentActiveSection) => set({ currentActiveSection }),
		setShouldShowATC: (shouldShowATC) => set({ shouldShowATC }),
		setSectionToOpen: (sectionToOpen) => set({ sectionToOpen })
	}));

export const { Provider: ProductStickyNavStoreProvider, useStore: useProductStickyNavStore } = createStoreContext(
	createProductStickyNavStore,
	'ProductStickyNavStore',
	// Rating renders outside the PDP (product cards, cart, search), where no provider is
	// mounted. For now, until the cases where Rating is called without a provider are cleaned
	// up and resolved, we have to allow a missing provider.
	{ allowMissingProvider: true }
);
